import { TranslationSchema } from './ru';

/**
 * English strings dictionary.
 */
export const en: TranslationSchema = {
  common: {
    brandName: 'QPRICE',
    save: 'Save',
    saved: 'Saved',
    saving: 'Saving...',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    all: 'All',
    clear: 'Clear',
    retry: 'Retry',
    confirm: 'Confirm',
    create: 'Create',
    add: 'Add',
    success: 'Success',
    error: 'Error',
    notFound: 'Not Found',
    loading: 'Loading...',
    search: 'Search',
    searchPlaceholder: 'Search items and discounts',
    themeToggle: 'Toggle theme',
    themeDark: 'Dark theme',
    themeLight: 'Light theme',
    themeSwitchToDark: 'Switch to dark theme',
    themeSwitchToLight: 'Switch to light theme',
    support: 'Support',
    supportPhone: '+7 777 246 84 83',
    supportPhoneLabel: 'Call partner support',
    day: 'day',
    daysFew: 'days',
    daysMany: 'days',
    today: 'today',
    tomorrow: 'tomorrow',
    yesterday: 'yesterday',
    daysAgo: 'days ago',
    tenge: '₸',
  },

  landing: {
    login: 'Log in',
    becomePartner: 'Become a partner',
    support: 'Support',
    eyebrow: 'Partner platform for any customer-facing business',
    heroTitleStrike: 'Idle hours',
    heroTitleAccent: 'turned into customers.',
    heroSub: 'QPrice is a direct sales channel for cafes, salons, fitness, auto services, shops, and any local business. Set a discount on an empty slot, slow inventory, or morning hour — and customers within 3 km will see it in the app and visit today.',
    howItWorks: 'See how it works',
    heroMeta: '3-minute setup · first month free',

    showcaseLabel: 'Live showcase of your discounts',
    showcaseTitle: 'One click — and your offer is right in the pocket of nearby customers.',
    showcaseDesc: 'Unlike coupon platforms and spam, QPrice only shows what is active right now and nearby. Customers open the app to decide where to go right now.',

    statsUsers: 'active app users',
    statsVenues: 'partners from various industries work with QPrice',
    statsSpeed: 'from sign-up to first active deal',
    statsCommission: 'commission on check — pay only fixed subscription',

    cardHaircut: 'Women haircut',
    cardHaircutMeta: 'weekdays · 11:00 — 15:00',
    cardFitness: 'Workout with trainer',
    cardFitnessMeta: 'available slot today',
    cardCoffee: 'Cappuccino with syrup',
    cardCoffeeMeta: 'happy hour · until 19:00',

    featuresTitle: 'Why partners stay',
    featuresSubtitle: 'This is the tool venue owners use to dial up venue capacity in real-time — just like a volume knob.',

    feat1Title: 'Direct channel',
    feat1Desc: 'QPrice takes no commission from the check. All revenue is yours — we earn on subscription, not your turnover.',

    feat2Title: 'Flexibility',
    feat2Desc: 'Discount by hour, by service, by category. Targeted choice: Friday 18:00 — 20:00, haircuts only, new customers only.',

    feat3Title: 'Speed',
    feat3Desc: 'Publish in 3 seconds. Enable or disable in a single tap.',

    feat4Title: 'Analytics & Menu',
    feat4Desc: 'Views, visits and repeats on every deal. Upload menu, dish of the day, stories — without separate services.',

    howTitle: 'How it works',
    howSubtitle: 'Three steps from an idle slot to a happy customer. No POS integration, no developers needed.',

    step1Number: '01',
    step1Title: 'Register your business',
    step1Desc: 'Phone number, WhatsApp code, name, address, and photos. Three minutes — and your profile is live in the app.',

    step2Number: '02',
    step2Title: 'Create a deal in one click',
    step2Desc: 'Pick a service or item, set the percentage, choose days and hours — even for one evening. Want to remove it in 10 minutes? You can.',

    step3Number: '03',
    step3Title: 'Customers arrive and pay full margin',
    step3Desc: 'The app shows the discount to people nearby. They come to you, buy more, and return again.',

    quoteText: 'We put a 30% discount on manicures on weekday mornings — and for the first time in six months filled our empty 9 AM to 1 PM slots. QPrice gave us control we never had before.',
    quoteAuthor: 'Diana M.',
    quoteRole: 'owner, beauty salon in Astana',

    ctaTitle: 'Try one discount. See who comes in.',
    ctaSub: 'Sign-up is free, first month is unlimited and free of charge. If it is not for you — simply walk away. If you like it — manage customer flow like never before.',
    ctaButton: 'Register venue',

    footerPartners: 'Partner Terms',
    footerClients: 'User Agreement',
    footerPrivacy: 'Privacy Policy',
    footerUgc: 'Publication Rules',
    footerSupport: 'Support',
    footerCities: 'Almaty, Astana and 12 more cities',
    footerCopyright: '© 2026 QPrice.',
  },

  auth: {
    choiceEyebrow: 'Partner Dashboard',
    choiceTitle: 'Your venue on QPrice',
    choiceSubtitle: 'Manage your menu, prices, and discounts directly — guests see updates instantly.',
    choiceNewVenueTitle: 'New venue',
    choiceNewVenueSub: 'Verify your phone number and submit venue details — takes only a couple of minutes.',
    choiceNewVenueAction: 'Register',
    choiceExistingVenueTitle: 'Already have a dashboard',
    choiceExistingVenueSub: 'Log in with phone number',
    choiceLoginButton: 'Log in with phone',
    choiceRegisterButton: 'Register venue',
    choiceHintLogin: 'If your cabinet is already set up — log in with your phone number.',
    choiceHintRegister: 'New venue: verify your number and submit venue details.',

    loginTitle: 'Partner Dashboard Login',
    loginSubtitle: 'Enter your phone number, we will send a code via WhatsApp.',
    registerTitle: 'Venue Registration',
    registerSubtitle: 'We will verify your number, then ask for your venue details — takes a couple of minutes.',
    confirmTitle: 'Verification',
    enterCode: 'Enter WhatsApp Code',
    codeNoticeRegistration: 'After verification, you will fill in your venue details to open your dashboard.',
    orgDetailsTitle: 'Venue Details',
    orgDetailsSubtitle: 'Final step: fill in your venue info — your dashboard will then be ready.',

    phoneLabel: 'Phone number',
    phonePlaceholder: '+7 (___) ___-__-__',
    phoneButton: 'Get code',
    phoneNotice: 'Verification code will be sent via WhatsApp',
    phoneValidationError: 'Phone number must contain 11 digits',

    codeLabel: 'Verification code',
    codeSentTo: 'Sent to',
    codeResend: 'Resend code',
    codeResendIn: 'Resend in',
    codeConfirm: 'Confirm',
    codeVerifying: 'Verifying...',
    secondsShort: 'sec',

    otherDoorNoCabinet: "Don't have a cabinet yet?",
    otherDoorHasCabinet: 'Already have a cabinet?',
    otherDoorRegister: 'Register',
    otherDoorLogin: 'Log in',

    wrongDoorCabinetNotFound: 'No cabinet found for this number. Would you like to register your venue?',
    wrongDoorCabinetExists: 'A cabinet already exists for this number. Would you like to log in?',

    legalNamePlaceholder: 'LLP "Company" or Sole Proprietorship',
    binIin: 'BIN / IIN',
    city: 'City',
    citySelect: 'Select city',
    legalAddressPlaceholder: 'City, street, building, suite',

    venueSectionTitle: 'Venue',
    venueSectionHint: 'This is how guests see your venue in the app: routing is built using this address.',
    venueName: 'Venue name',
    venueNamePlaceholder: 'e.g. Cozy Cafe',
    venueNameDefaultPlaceholder: 'Coffee Plus',
    venueAddress: 'Venue address',
    venueAddressPlaceholder: 'Almaty, Dostyk ave 12',
    mapPickButton: 'Pick on the map',
    mapPickHint: 'Click your building — the address fills in by itself. You can drag the pin.',
    mapLookupLoading: 'Looking up the address…',
    mapAddressHouse: 'The address is filled in from the pin — please check it.',
    mapAddressStreet: 'Only the street was found — add the building number.',
    mapAddressKeptPre: 'The pin only gave',
    mapAddressKeptPost: '— we kept the address you typed.',
    mapAddressFoundPre: 'The pin gave',
    mapAddressKeptHousePost: '— we kept the building number you typed.',
    mapAddressKeptEarlierPost: '— we kept the previous address, check the building number.',
    mapAddressNone: 'Could not get the address from the pin — please type it in.',
    mapPointLabel: 'Pin',
    venueCategory: 'Main category',
    venueCategorySelect: 'Select category',
    venueCategoryOther: 'Other',

    consentText: 'I accept the terms of the',
    consentLink: 'partner agreement',
    consentRequired: 'You must accept the terms to proceed',
    offerConsentPre: 'I accept the terms of the',
    offerConsentLink: 'partner public offer',
    offerConsentEdition: 'as of',

    submitRegistration: 'Complete registration',
    submitting: 'Submitting...',
    loginSuccess: 'Logged in successfully',
    cabinetCreated: 'Cabinet created successfully',
    notYourNumber: 'Not your number?',
    logout: 'Log out',
    loadingReferences: 'Loading…',
    referencesError: 'Failed to load reference directories. Check connection and refresh.',
    submitFormError: 'Failed to submit form. Please try again.',

    validationVenueName: 'Specify venue name',
    validationVenueNameShort: 'Venue name is too short',
    validationCity: 'Select a city',
    validationVenueAddress: 'Specify venue address',
    validationVenueAddressShort: 'Venue address is too short',
    validationCategory: 'Select a main category',
    validationOffer: 'Please accept the offer terms',
  },

  nav: {
    home: 'Home',
    catalog: 'Menu',
    discounts: 'Discounts',
    promo: 'Promo',
    qr: 'QR Codes',
    billing: 'Subscription',
    accountMenu: 'Account menu',
    editProfile: 'Edit profile',
    logout: 'Log out',
    ariaTopTabs: 'Cabinet sections',
    ariaBottomNav: 'Bottom navigation',
  },

  cabinet: {
    createDiscount: 'Create deal',
    venueProfile: 'VENUE PROFILE',
    categoryNote: 'CATEGORIES',
    categoryNoteFew: 'CATEGORIES',
    categoryNoteOne: 'CATEGORY',
    discountNote: 'DISCOUNTS',
    discountNoteFew: 'DISCOUNTS',
    discountNoteOne: 'DISCOUNT',
    storiesAndBanner: 'STORIES & BANNER',
    subscription: 'SUBSCRIPTION',

    subAccessClosed: 'ACCESS CLOSED',
    subClosesToday: 'CLOSES TODAY',
    subClosesTomorrow: 'CLOSES TOMORROW',
    subClosesIn: 'CLOSES IN',
    subOpenBilling: 'Open subscription',

    completenessTitle: 'Venue completeness',
    completenessHint: 'The more complete your profile, the more often guests choose your place',
    profileFilled: 'FILLED',
    ariaProfileCompleteness: 'Venue profile completeness',
    whatToImprove: 'What to improve →',
    cardFilledPercent: 'Profile filled',
    fillAction: 'Complete profile',
    requiredTag: 'REQUIRED',

    trafficTitle: 'Traffic',
    trafficPeriod: 'Period',
    traffic7d: '7 days',
    traffic30d: '30 days',
    traffic90d: '90 days',
    metricPartnerViews: 'Profile views',
    metricPartnerViewsNote: 'venue visits',
    metricCatalogOpens: 'Menu opens',
    metricCatalogOpensNote: 'menu views',
    metricDiscountOpens: 'Deal opens',
    metricDiscountOpensNote: 'from app',
    metricContactClicks: 'Contact clicks',
    metricContactClicksNote: 'calls, socials, route',
    metricQrScans: 'QR scans',
    metricQrScansNote: 'table cards',
    metricNfcTaps: 'NFC taps',
    metricNfcTapsNote: 'tag taps',
    deltaNoData: 'no data for previous period',
    deltaToPrev: 'vs previous period',
    sparklineAria: 'Daily trend',

    statsViews: 'Profile views',
    statsMenuViews: 'Menu views',
    statsFavorites: 'In favorites',
    statsActiveDiscounts: 'Active deals',

    categoriesInCatalog: 'Categories in catalog',
    categoriesCountNote: 'showcase sections',
    activeDiscounts: 'Active deals',
    activeDiscountsNote: 'currently visible to guests',
    rating: 'Rating',
    ratingNote: 'average rating',
    reviewsCount: 'Reviews',
    reviewsCountNote: 'total over all time',
    allDiscounts: 'Total deals',
    workNow: 'Active now',
    workNowNote: 'visible in the app',
    notWorking: 'Inactive',
    notWorkingNote: 'disabled or expired',
    averageDiscount: 'Average discount',

    reviewsTitle: 'Guest reviews',
    noReviews: 'No reviews yet',
    reviewReportsTitle: 'Review reports',
    reviewReportsEmpty: 'No reports under review',

    catalogTitle: 'Menu & items',
    addCategory: '+ Category',
    addItem: '+ Item',
    createCategoryBtn: 'Create category',
    emptyCatalog: 'There are no categories yet. Create your first category to start showcasing items.',
    emptyCatalogTitle: 'Catalog is empty',
    emptyCatalogDesc: 'Create your first category — items are added to it, and discounts are applied to items.',
    nothingFound: 'Nothing found for this query',
    noItemsYet: 'No items in categories yet',
    newCategory: 'New category',
    categoryPlaceholder: 'e.g.: Drinks, Haircuts, Car Wash',
    deleteCategory: 'Delete category',
    firstCreateCategory: 'Create a category first',
    price: 'Price',
    priceWithDiscount: 'With discount',
    item: 'Item',
    category: 'Category',
    discount: 'Discount',
    noDiscount: 'NO DISCOUNT',
    shown: 'Showing',
    outOf: 'of',
    positionsCount: 'items',

    discountsTitle: 'Venue discounts',
    emptyDiscounts: 'You have no deals yet. Create your first discount to attract new guests.',
    emptyDiscountsDesc: 'A discount is why customers open QPrice. Create your first one: for an entire category or specific items, on specific days and hours.',
    discountActive: 'Active now',
    discountSchedule: 'Scheduled',
    discountPercent: 'Discount',
    discountCol: 'Deal',
    timeCol: 'Time',
    periodCol: 'Period',
    actionsCol: 'Actions',
    expired: 'Expired',
    openCatalog: 'Open catalog',
    days: 'Days',
    allStates: 'Any state',
    sortByTime: 'By start time',
    sortBySize: 'By discount size',
    sortByNew: 'Newest first',
    reset: 'Reset',
    noDiscountsFiltered: 'No promotions match selected filters',

    promoTitle: 'Promo & Stories',
    storiesTitle: 'Venue stories',
    addStory: 'Add story',
    adCampaignsTitle: 'Ad campaigns',

    qrTitle: 'QR table tents & NFC tags',
    qrSubtitle: 'Guests open your menu without installing any app',
    qrDownloadPdf: 'Download for print',
    qrTableNumber: 'Table #',
    qrTargetsMenu: 'Menu',
    qrTargetsMenuHint: 'Table tent: guests instantly see dishes and prices',
    qrTargetsPartner: 'Venue card',
    qrTargetsPartnerHint: 'Sticker at entrance, display window, receipt',
    qrSourceQr: 'QR code',
    qrSourceQrHint: 'Printed on paper, works on any phone',
    qrSourceNfc: 'NFC tag',
    qrSourceNfcHint: 'Written to tag; if NFC disabled, QR is always available',
    qrModeSingle: 'Single code',
    qrModeBatch: 'By tables',
    qrTableFrom: 'Tables from',
    qrTableTo: 'to',
    qrShowCodes: 'Show codes',
    qrPrint: 'Print',
    qrDownload: 'Download',
    qrCopyUrl: 'Copy link',
    qrCopied: 'Copied',
    qrCopyImage: 'Copy image',
    qrCopyImageFailed: 'The browser didn’t allow copying the image — download the PNG.',
    qrPageSub: 'The code on the table opens your menu. Users with the app open it in-app, others in browser with an install prompt.',
    qrNotice: 'Scans are tracked separately from regular menu visits — visible in home analytics. If printing for tables, each table is tracked individually.',
    qrTargetLegend: 'Where code leads',
    qrSourceLegend: 'Medium',
    qrCountLegend: 'Quantity',
    qrYourCode: 'Your code',
    qrCodesCount: 'Codes',
    qrPrintNotice: 'Print at least 3 cm per side and leave white margins around it — otherwise cameras may fail to scan.',
    qrEmpty: 'Codes have not been generated yet.',
    qrHowItWorks: 'How it works',
    qrHowStep1: 'A guest points the camera — the menu opens with your current prices and active discounts.',
    qrHowStep2: 'If the app is already installed, it captures the link and opens the menu inside.',
    qrHowStep3: 'If not, the menu opens in the browser, with a prompt to install the app below.',
    qrHowStep4: 'For NFC, write the same link to the tag. If NFC is disabled, the tag cannot be read, so keep the QR on the table.',

    billingPageTitle: 'Plans & Subscription',
    currentTariff: 'Current plan',
    extendAction: 'Extend subscription',
    noPaymentNeeded: 'Payment not needed yet',
    noPaymentNeededDesc: 'First launch your venue using the button on Home. The trial period starts upon launch.',
    toMain: 'To Home',

    legalTitle: 'Legal details',
    legalHint: 'Optional. Fill them in when you need a contract or closing documents — any fields, at any time.',
    legalPrivacyNote: 'Legal details are visible only to QPrice — guests never see them.',
    legalForm: 'Ownership form',
    legalFormNone: 'Not selected',
    legalName: 'Full legal name',
    legalNamePlaceholder: 'Coffee Plus LLP',
    legalNumberHint: '12 digits from the registration certificate',
    legalNumberPlaceholder: '12 digits',
    legalAddress: 'Legal address',
    legalAddressHint: 'The address from your registration documents, not the venue address.',
    legalAddressPlaceholder: 'Almaty, Abay ave 1, office 5',
    legalNameShort: 'Legal name is too short',
    legalAddressShort: 'Legal address is too short',
    legalSave: 'Save legal details',
    legalSaving: 'Saving…',
    legalSaved: 'Legal details saved',
    legalSaveError: 'Failed to save legal details. Please try again.',
    legalEmpty: 'Not filled in. This is optional — you will need them for the contract and closing documents.',
    legalFill: 'Fill in',
    legalEdit: 'Edit',
    legalOfferAccepted: 'Offer accepted',
    legalOfferEdition: 'edition',
  },

  discounts: {
    eyebrow: 'Deals',
    eyebrowCategory: 'whole category',
    eyebrowItems: '{count} items',
    eyebrowPieces: '{count} pcs',
    eyebrowNothing: 'nothing chosen',
    titleNew: 'New discount',
    titleEdit: 'Edit discount',
    dirty: 'Unsaved changes',
    clean: 'All changes saved',
    cancel: 'Cancel',
    create: 'Create discount',
    save: 'Save',
    saving: 'Saving…',
    created: 'Discount created',
    updated: 'Discount updated',
    saveFailed: 'Could not save the discount',
    footNow: 'The discount goes live right after saving and works only within the chosen window.',
    footLater: 'The discount appears in the app on {date} and works only within the chosen window.',

    cardMain: 'Discount',
    cardMainHint: 'Guests see the name in the app. The type defines how the price is calculated.',
    name: 'Name',
    namePlaceholder: 'For example: Tea with a pastry until 18:00',
    nameHint: 'Optional. Without a name, the discount is labelled by what it applies to.',
    kind: 'Discount type',
    kindGroup: 'On items',
    kindGroupHint: 'Percent or tenge off every item in a category or a list.',
    kindCombo: 'Combo',
    kindComboHint: 'A set of items for one price: tea and a pastry for 1 500 ₸.',

    cardTarget: 'Applies to',
    cardTargetHint: 'A whole menu category or selected items.',
    target: 'Discount target',
    targetCategory: 'Whole category',
    targetItems: 'Selected items',
    targetCategoryHint: 'Choose a category. A discount on a category also covers its subcategories.',
    targetItemsHint: 'Open a category and tick the items.',
    targetPickedCategory: 'Whole category “{name}” · items: {count}',
    targetPickedItems: 'Items ticked: {count}',
    errorTargetCategory: 'Choose a category',
    errorTargetItems: 'Tick at least one item',

    cardValue: 'Discount size',
    cardValueHint: 'Taken off the price of every item: as a percent or in tenge.',
    value: 'Size',
    valueUnit: 'Percent or tenge',
    valuePercentHint: '1 to 100 % of the regular price.',
    valueAmountHint: 'Whole tenge off every item.',
    valueAmountHintMax: 'No more than {price} — the price of the cheapest item.',
    errorPercent: 'A percent discount is a whole number from 1 to 100',
    errorAmount: 'Enter the discount amount — whole tenge, at least 1',
    errorAmountTooBig:
      'A {amount} discount is more than the price of “{name}” — {price}. Lower the discount or use a percent.',
    errorAmountNoItems: 'The category has no items, so a tenge discount has nothing to apply to. Use a percent.',
    preview: 'Before → after',
    previewCheapest: 'Cheapest',
    previewPriciest: 'Most expensive',
    previewSingle: 'Item',
    previewEmpty: 'Choose what the discount applies to — prices before and after will appear here.',

    cardCombo: 'Combo contents',
    cardComboHint: 'Tick the items and set quantities. Guests take the whole set.',
    comboEmpty: 'Empty so far — tick items in the menu below.',
    comboPick: 'Menu items',
    comboQuantity: 'Quantity: {name}',
    comboLess: 'Fewer: {name}',
    comboMore: 'More: {name}',
    comboRemove: 'Remove from combo: {name}',
    comboUnitPrice: '{price} each',
    comboHidden: 'Not on sale — guests won’t see the combo while the item is hidden',
    comboRegular: 'Regular price of the set',
    errorCombo: 'A combo needs at least two pieces: two items or one item twice',

    cardBundle: 'Combo price',
    cardBundleHint: 'What guests pay for the whole set. It must be below the regular price.',
    bundle: 'Combo price, ₸',
    bundleHint: 'Whole tenge for the whole set.',
    bundleRegular: 'Regular price',
    bundlePrice: 'Combo price',
    bundleSaving: 'Guest saves',
    bundleNoSaving: 'no saving',
    errorBundle: 'Enter the combo price — whole tenge',
    errorBundleTooHigh: 'The combo price must be below the regular price of the set — {price}',

    cardWhen: 'When it runs',
    cardWhenHint: 'A time window and days of the week. Days count from the start of the window, not its end.',
    timeFrom: 'From',
    timeTo: 'To',
    timeOvernight: 'The window crosses midnight — until {time} the next day.',
    errorTime: 'Set the start and end time',
    errorTimeSame: 'Start and end cannot be the same',
    days: 'Days of the week',
    daysWeekdays: 'Weekdays',
    daysWeekend: 'Weekend',
    daysAll: 'Every day',
    daysClear: 'Clear',
    errorDays: 'Choose at least one day of the week',
    dayMon: 'Mo',
    dayTue: 'Tu',
    dayWed: 'We',
    dayThu: 'Th',
    dayFri: 'Fr',
    daySat: 'Sa',
    daySun: 'Su',

    cardPeriod: 'Deal period',
    cardPeriodHint: 'Calendar dates; the time window is set above.',
    startsAt: 'Starts on',
    startsAtHint: 'Empty — the deal is already running.',
    endsAt: 'Ends on',
    endsAtHint: 'Inclusive. Empty — no end date.',
    errorEndsAt: 'The end date cannot be earlier than the start date',

    menuLoading: 'Loading the menu…',
    menuError: 'Could not load the menu',
    menuRetry: 'Retry',
    menuEmpty: 'The menu has no categories yet. Create a category and add items to it.',
    treeBranch: 'category with subcategories',
    treeCount: '{count} items',
    treeChecked: '{count} ticked',
    treeEmpty: 'No items in this category yet',
    treeSelectAll: 'Select all',
    treeUnselectAll: 'Clear all',
    treeExpand: 'Expand category',
    treeCollapse: 'Collapse category',

    filterKind: 'Deal type',
    filterKindAll: 'All types',
    filterKindGroup: 'On items',
    filterKindCombo: 'Combo',
    badgeCombo: 'Combo',
    scopeCategory: 'Category “{name}”',
    scopeCategoryUnnamed: 'Category',
    scopeNoItems: 'No items chosen',
    scopeItemOne: 'item',
    scopeItemFew: 'items',
    scopeItemMany: 'items',
    subtitleCategory: 'Category discount',
    subtitleItems: 'Items discount',
    subtitleCombo: 'Combo set',
    comboInstead: 'instead of {price}',
    comboNoSaving: 'no saving',
    comboNoSavingTitle:
      'The combo price is not below the current sum of its items — guests don’t see this combo',
    kpiKinds: '{group} on items · {combo} combo',
    kpiAverageNote: 'max −{max} % · percent discounts only',
    kpiAverageNone: 'no percent discounts',
  },
};
